import request from '@/utils/request'
// 查询退款记录 GET /api/RefundInfo/RefundList
export function RefundList(query) {
  var query_ = {}
  query_.pageIndex = query.pageIndex
  query_.pageSize = query.pageSize
  query_.userId = query.userId
  if (query.identity) {
    query_.identity = query.identity
  }
  if (query.startTime) {
    query_.startTime = query.startTime
  }
  if (query.endTime) {
    query_.endTime = query.endTime
  }
  return request({
    url: '/api/RefundInfo/RefundList',
    method: 'get',
    params: query_
  })
}
// 查询转账记录GET /api/RefundInfo/TransferList
export function TransferList(query) {
  var query_ = {}
  query_.pageIndex = query.pageIndex
  query_.pageSize = query.pageSize
  query_.userId = query.userId
  if (query.identity) {
    query_.identity = query.identity
  }
  if (query.startTime) {
    query_.startTime = query.startTime
  }
  if (query.endTime) {
    query_.endTime = query.endTime
  }
  return request({
    url: '/api/RefundInfo/TransferList',
    method: 'get',
    params: query_
  })
}

//  获取提现列表
export function qryReturnCoin(query) {
  return request({
    url: '/api/financeInfo/qryReturnCoin',
    method: 'post',
    params: query
  })
}
// 查询账户流水
export function qryAccountFlow(query) {
  var query_ = {}
  query_.pageIndex = query.pageIndex
  query_.pageSize = query.pageSize
  query_.userName = query.userName
  query_.type = query.type
  query_.identity = query.identity
  query_.fieldName = query.fieldName
  query_.loginNo = query.loginNo
  if (query.startTime) {
    query_.startTime = query.startTime
  }
  if (query.endTime) {
    query_.endTime = query.endTime
  }
  return request({
    url: '/api/financeInfo/qryAccountFlow',
    method: 'post',
    params: query_
  })
}
// 提现成功
export function verifyPass(data) {
  return request({
    url: '/api/financeInfo/verifyPass',
    method: 'post',
    data
  })
}

// 提现失败
export function verifyNoPass(data) {
  return request({
    url: '/api/financeInfo/verifyNoPass',
    method: 'post',
    data
  })
}

// 获取银行列表
export function getBankInfo() {
  return request({
    url: '/api/user/getBankInfo',
    method: 'get'
  })
}

// 修改银行卡信息
export function updateBankInfo(query) {
  return request({
    url: '/api/user/updateBankInfo',
    method: 'post',
    data: query
  })
}

// 申请提现到银行卡
export function applyReturnCoin(query) {
  return request({
    url: '/api/financeInfo/applyReturnCoin',
    method: 'post',
    params: query
  })
}

// POST /api/financeInfo/qryAgentUser 查询场地方、代理商 （名称，余额）
export function qryAgentUser(query) {
  return request({
    url: '/api/financeInfo/qryAgentUser',
    method: 'post',
    params: query
  })
}

// POST /api/financeInfo/deductRemain 扣除余额
export function deductRemain(query) {
  return request({
    url: '/api/financeInfo/deductRemain',
    method: 'post',
    params: query
  })
}

// GET /api/financelnfo/qryRechargeSetting 查询充值设置
export function qryRechargeSetting() {
  return request({
    url: '/api/financeInfo/qryRechargeSetting',
    method: 'get'
  })
}

// POST /api/financeInfo/rechargeSetting 充值价格设置
export function rechargeSetting(query) {
  return request({
    url: '/api/financeInfo/rechargeSetting',
    method: 'post',
    data: query
  })
}

// POST /api/financeInfo/exportAccountFlowExcel 导出流水报表
export function exportAccountFlowExcel(data) {
  return request({
    url: '/api/financeInfo/exportAccountFlowExcel',
    method: 'post',
    params: data
  })
}

/**
 * POST /api/home/getBankApplyVaildateCode 银行卡提现获取验证码
 * @param {*} params
 * @returns
 */
export function getBankApplyVaildateCode(params) {
  return request({
    url: '/api/home/getBankApplyVaildateCode',
    method: 'post',
    params
  })
}

// POST /api/wxPay/verifyDone 提现审核已处理
export function verifyDone(data) {
  return request({
    url: '/api/financeInfo/verifyDone',
    method: 'post',
    data
  })
}

/**
 *POST /api/financeInfo/assignRemain 发放佣金
 * @param {*} params
 * @returns
 */
export function assignRemain(params) {
  return request({
    url: '/api/financeInfo/assignRemain',
    method: 'post',
    params
  })
}

